import React from 'react'
import i18n from '../../../simple-react-i18n'
import { Grid } from '@mui/material'
import Input from '../../../components/forms/Input'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import { ButtonMUI } from '../../../components/styled/Buttons'
import PropTypes from 'prop-types'
import DtoStation from '../../../station/dto/DtoStation'

const CEMAGREF_ExportPanel = ({
    onChange = () => {},
    onChangeFilter = () => {},
    onApplyExport = () => {},
    selectedStations = [],
    tmpFilter = {},
    hideApplyButton = false,
}) => {
    return (
        <fieldset>
            <legend className='italic-label padding-right-1 padding-left-1'>{ i18n.exportCriterias }</legend>
            <Grid container spacing={1} alignItems='center'>
                <Grid size={2}>
                    <Input
                        title={ i18n.defineDirectory }
                        value={ tmpFilter.exportDir }
                        onChange={ v => onChangeFilter({ exportDir: v }) }
                    />
                </Grid>
                <Grid size={2}>
                    <SimpleDatePicker
                        value={ tmpFilter.startDate }
                        label={ i18n.startDate }
                        onChange={ v => onChangeFilter({ startDate: v }) }
                    />
                </Grid>
                <Grid size={2}>
                    <SimpleDatePicker
                        value={ tmpFilter.endDate }
                        label={ i18n.endDate }
                        onChange={ v => onChangeFilter({ endDate: v }) }
                    />
                </Grid>
                <Grid size={3}>
                    <ButtonMUI
                        style={{ width: '100%' }}
                        onClick={ () => onChange({ selectStationIsOpen: true }) }
                    >{ `${i18n.selectStations} (${selectedStations.length})` }</ButtonMUI>
                </Grid>
                { !hideApplyButton && (
                    <Grid size={3}>
                        <ButtonMUI
                            fullWidth
                            onClick={ onApplyExport }
                        >{ i18n.apply }</ButtonMUI>
                    </Grid>
                ) }
            </Grid>
        </fieldset>
    )
}


CEMAGREF_ExportPanel.propTypes = {
    onChange: PropTypes.func,
    onChangeFilter: PropTypes.func,
    selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
    tmpFilter: PropTypes.shape({
        startDate: PropTypes.number,
        endDate: PropTypes.number,
    }),
    onApplyExport: PropTypes.func,
    hideApplyButton: PropTypes.bool,
}

export default CEMAGREF_ExportPanel
